import { useParams, Navigate } from "react-router-dom";
import { getRange } from "../data/products";
import { Benefits, SpecTable } from "../components/product/Shared";
import { ProductBanner } from "../components/product/ProductBanner";
import { PalativaDetail } from "../components/product/PalativaDetail";
import { OptibiteDetail } from "../components/product/OptibiteDetail";
import { AvitivaDetail } from "../components/product/AvitivaDetail";
import { EnquiryBlock } from "../components/home/Closing";
import { useTitle } from "../lib/useTitle";

const DETAIL = { palativa: PalativaDetail, optibite: OptibiteDetail, avitiva: AvitivaDetail };

export default function ProductPage() {
  const { slug } = useParams();
  const r = getRange(slug);
  useTitle(r ? `${r.name} — ${r.category} | Gait Naurish Ltd.` : "Gait Naurish Ltd.");
  if (!r) return <Navigate to="/" replace />;
  const Detail = DETAIL[r.slug];
  return (
    <main data-testid={`product-page-${r.slug}`}>
      <ProductBanner r={r} />
      <Benefits r={r} />
      <Detail r={r} />
      <SpecTable r={r} />
      <div className="border-t border-[var(--line)]">
        <EnquiryBlock defaultProduct={r.name} />
      </div>
    </main>
  );
}
